angular.module("screensApp").factory("AnalysisService", function ($http, $rootScope) {
  return {
    getEventAnalysisData: function (eventID) {
      return $http.get($rootScope.url.CentralSBAnalysisURL + eventID + "/event-analyze/true");
    },
    getOddsData: function (eventID) {
      return $rootScope.setOfferUrl("OfferEventMasterChanceType/Event/" + eventID + "/Zone/" + $rootScope.config.TimeZone + "/LanguageID/" + $rootScope.config.LanguageId);
    }
  };
});
